import { Box } from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollProgressBar from './ScrollProgressBar';
import ParticlesLayer from './ParticlesLayer';
import GradientBlobsLayer from './GradientBlobsLayer';
import GridOverlayLayer from './GridOverlayLayer';
import QuickOrderButton from '../UI/QuickOrderButton';
import CookieConsent from '../UI/CookieConsent';

const Layout = ({ children }) => {
  return (
    <Box 
      sx={{ 
        position: 'relative', 
        minHeight: '100vh',
        width: '100%',
        background: 'linear-gradient(180deg, #0b0f1a 0%, #0e1424 50%, #111827 100%)',
        overflowX: 'hidden',
        willChange: 'auto',
        WebkitOverflowScrolling: 'touch',
        '&::before': {
          content: '""',
          position: 'fixed',
          inset: 0,
          background: 'linear-gradient(180deg, #0b0f1a 0%, #0e1424 50%, #111827 100%)',
          zIndex: -1,
          pointerEvents: 'none',
        },
      }}
    >
      {/* Background Layers - Behind everything */}
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 0,
          pointerEvents: 'none',
          overflow: 'hidden',
          willChange: 'transform',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
        }}
      >
        <GridOverlayLayer />
        <GradientBlobsLayer />
        <ParticlesLayer />
      </Box>

      {/* Scroll Progress Bar - Top layer */}
      <ScrollProgressBar />

      {/* Navbar - Above background layers */}
      <Navbar />

      {/* Main Content - Above background, below navbar */}
      <Box 
        component="main" 
        sx={{ 
          position: 'relative', 
          zIndex: 1,
          minHeight: '100vh',
          background: 'transparent',
          willChange: 'auto',
        }}
      >
        {children}
      </Box>

      {/* Footer */}
      <Footer />

      {/* Floating Elements */}
      <QuickOrderButton />
      <CookieConsent />
    </Box>
  );
};

export default Layout;

